import { Injectable } from '@angular/core';

import { ClientConfigProductName, ContentService, PromoApiService, UserLoginEvent, UserService } from '@frontend/vanilla/core';
import { BehaviorSubject, Observable, Subject, filter, takeUntil } from 'rxjs';

import { DashboardContentPath } from '../toggle-navigation/model';

export class VipDetails {
    isVipUser: boolean;
    enableHostDetails: boolean;
    hostName: string;
    hostEmail: string;
    hostPhone: string;
    hostTeam: string;
}

@Injectable({
    providedIn: 'root',
})
export class UserBannerService {
    private readonly destroy$ = new Subject<void>();
    rewardsHubState: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    isVipUser: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    private vipStatusLoaded = false;

    private lastContentFetchTime: number = 0;
    private readonly cacheTimeMs: number = 30 * 60 * 1000;

    constructor(
        private contentService: ContentService,
        private apiService: PromoApiService,
        private userService: UserService,
    ) {}

    fetchDashboardContent(): void {
        this.lastContentFetchTime = Date.now();
        this.contentService.getJsonFiltered(DashboardContentPath, ClientConfigProductName.PROMO).subscribe((data) => {
            this.rewardsHubState.next(data);
        });

        if (this.userService.isAuthenticated) {
            this.loadUserVipStatus();
        } else {
            this.userService.events
                .pipe(
                    filter((e) => e instanceof UserLoginEvent),
                    takeUntil(this.destroy$),
                )
                .subscribe(() => this.loadUserVipStatus());
        }
    }

    private loadUserVipStatus(): void {
        if (!this.vipStatusLoaded) {
            this.vipStatusLoaded = true;
            this.apiService.get('rewardshub/getIsUserVip').subscribe({
                next: (response: VipDetails) => {
                    const isVip = response.isVipUser;
                    this.isVipUser.next(isVip);
                },
                error: () => {
                    this.isVipUser.next(false);
                },
            });
        }
    }

    getRewardsHubData(): Observable<any> {
        const now = Date.now();
        if (now - this.lastContentFetchTime > this.cacheTimeMs) {
            this.fetchDashboardContent();
        }
        return this.rewardsHubState.asObservable();
    }
}
